define([
    'jQuery',
    'underscore',
    'library/fcse-facets/facetsMixin',
    'library/fcse-compatibility/object',
    'library/fcse-widget/widget'],
  function($, _, FacetsMixin, Object, Widget) {

    var Checklist = function (element, options) {
      Widget.apply(this, arguments);

      //Default options
      var defaultOptions = {
        'selectedClassName': 'is-selected',
        'disabledClassName': 'is-disabled',
        'facetProperty': null
      };
      this.addOptions(defaultOptions, options);

      this._registerClickEvent();
    };

    Checklist.prototype = $.extend(Object.create(Widget.prototype), FacetsMixin, {
      /**
       * Returns the facets
       */
      getFacets : function() {

      },

      /**
       * Applys the facets to the widget
       * @param {type} facets
       * @returns {undefined}
       */
      setFacets : function(facets) {
        // If no facets are set, nothing has to be done here.
        if(!facets) {
          return;
        }

        var self = this;
        this._facets = facets;

        //Update facet
        //$('[data-fcse-role="checkboxbutton--facet"]', this.element).text(0);

        $('[data-value]', this.element).each($.proxy(function(index, element){
          var code = $(element).attr('data-value');
          if (this._facets.hasOwnProperty(code)){
            if (this._facets[code] > 0){
              $(element).removeClass(this.option('disabledClassName'));
            } else {
              $(element).removeClass(this.option('selectedClassName'));
              $('input[type=checkbox]', element).prop('checked', false);
              $(element).addClass(this.option('disabledClassName'));
            }
            $('[data-fcse-role="checkboxbutton--facet"]', element).text(this._facets[code]);
          }
        }, this));
      },

      /**
       * Gets the values and triggers them
       */
      _getAndTriggerValues: function(){
        var value = [];
        $('[data-value]', this.element).each(function(index, element){
          if($(element).find('input:checkbox').is(':checked')){
            value.push($(element).attr('data-value'));
          }
        });

        if (!_.isEqual(this.value, value)) {
          this.setValue(value);
        }
      },

      /**
       * Register click event handler
       * @returns {undefined}
       */
      _registerClickEvent: function () {
        var self = this;
        $('[data-value]', this.element).on("click", function (e) {
          var $target = $(this);
          if ($target.hasClass(self.option('disabledClassName'))){
            e.preventDefault();
            return;
          }

          var selected = false;
          if(!$target.hasClass(self.option('selectedClassName'))){
            selected = true;
          }
          e.preventDefault();
          e.stopImmediatePropagation();
          $('input:checkbox', $target).prop('checked', selected ? 'checked' : null);

          self._getAndTriggerValues();
        });

        /**
         * Click event for the checkboxes
         * Fix for this problem: Checkbox being checked twice when inside an li with a click event
         */
        $('input[type=checkbox]', this.element).on('click', function(e) {
          e.stopPropagation();
          self._getAndTriggerValues();
        });
      },

      getValueFromUi: function () {
        var value = [];
        $('[data-value]', this.element).each(function(index, element){
          if($(element).find('input:checkbox').is(':checked')){
            value.push($(element).attr('data-value'));
          }
        });
        return value;
      },

      setValueToUi: function () {
        var self = this;
        $('[data-value]', this.element).each(function(index, element){
          var $element = $(element);
          if ($.inArray($element.attr('data-value'), self.getValue()) !== -1){
            $element.addClass(self.option('selectedClassName'));
            $('input[type=checkbox]', $element).prop('checked', true);
            $(self.option('checkboxSelector'), $element).addClass(self.option('checkboxSelectedClassName'));
          } else {
            $element.removeClass(self.option('selectedClassName'));
            $('input[type=checkbox]', $element).prop('checked', false);
            $(self.option('checkboxSelector'), $element).removeClass(self.option('checkboxSelectedClassName'));
          }
        });
      },

      formatValue: function () {
        var self = this;
        var result = '';
        if (!(this.value && this.value.length)) {
          return this.element.data('any');
        }
        if (this.value.length === 1) {
          result = $('[data-value="' + this.value[0] + '"][data-label]', this.element).data('label');
        } else {
          result = this.element.data('plural').replace('%count%', this.value.length);
        }
        return result;
      }
    });

    return Checklist;
  }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/checklist/checklist.js